import { render } from "./overview.vue?vue&type=template&id=46b8c27a&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"

import "./overview.vue?vue&type=style&index=0&id=46b8c27a&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b8c27a"],['__file',"resources/js/pages/messages/overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46b8c27a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46b8c27a', __exports__)) {
    console.log('reload')
    api.reload('46b8c27a', __exports__)
  }
  
  module.hot.accept("./overview.vue?vue&type=template&id=46b8c27a&scoped=true", () => {
    console.log('re-render')
    api.rerender('46b8c27a', render)
  })

}


export default __exports__